import { Alert, Modal, Space, Typography, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  getEmployeeList,
  updateEmployeePhoto,
} from "../../store/slices/employeeSlice";

const { Title, Text } = Typography;

export const UpdatePhotoModal = ({ closePopup, item }) => {
  const formikRef = useRef(null);

  const handleCancel = () => {
    closePopup(false);
  };

  const dispatch = useDispatch();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const initialValues = {
    file: null,
  };

  const validationSchema = Yup.object({
    file: Yup.mixed().required("File is required"),
  });

  const onSubmit = (values) => {
    setConfirmLoading(true);

    const formData = new FormData();

    formData.append("file", values.file);

    dispatch(
      updateEmployeePhoto(item.id, formData, () => {
        setConfirmLoading(false);
        closePopup(false);
        dispatch(getEmployeeList());
      })
    );
  };

  return (
    <Modal
      title={"Edit Employee"}
      open={true}
      confirmLoading={confirmLoading}
      onOk={() => {
        formikRef.current.submitForm();
      }}
      width={768}
      onCancel={handleCancel}
    >
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form>
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <div>
                  <Title level={5}>Upload Photo *</Title>
                  <Alert
                    message="Please upload image with size less than 500KB."
                    type="warning"
                    style={{ marginTop: "4px", marginBottom: "16px" }}
                  ></Alert>
                  <Upload.Dragger
                    name="file"
                    action={"/"}
                    multiple={false}
                    fileList={values.file ? [values.file] : []}
                    onChange={(value) =>
                      setFieldValue("file", value.file.originFileObj)
                    }
                    accept=".jpeg,.jpg,.png"
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                    <p className="ant-upload-hint">
                      Support for a .jpeg, .jpg, .png
                    </p>
                  </Upload.Dragger>
                  {errors.file && touched.file ? (
                    <Text type="danger">{errors.file}</Text>
                  ) : null}
                </div>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};
